/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-props-no-spreading */
import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHouse, faFileInvoiceDollar, faCircleQuestion, faCircleArrowRight, faFileLines, faGrip,
} from '@fortawesome/free-solid-svg-icons';
import logo from '@assets/logo.svg';
import PrimaryFill from '@assets/Primary_fill.svg';
// import cx from 'classnames';
import Popover from '@mui/material/Popover';
import { useAuthContext } from '@hooks/useAuthContext';

import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import PropTypes from 'prop-types';
import classes from './Navigation.module.css';
import './navigationbar.css';
import useConnectionContext from '../../hooks/useConnectionContext';

function Logo() {
  return <img src={logo} className={classes.logo} alt="seel logo" />;
}

function Help() {
  return (
    <div
      className={classes.help}
      onClick={() => {
        window.open('//kover2618.zendesk.com/hc/en-us');
      }}
    >
      <FontAwesomeIcon className={classes.help_icon} icon={faCircleQuestion} />
      <div className={classes.help_text}>Help</div>
    </div>
  );
}

function Avatar({ authInfo }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const { onboarding, signout, merchantName = '' } = authInfo;
  const { email } = onboarding || {};
  const navigate = useNavigate();
  if (!email) {
    return null;
  }

  const firstLetter = (merchantName || email)[0] || '';
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (event) => {
    setAnchorEl(null);
    event.preventDefault();
    event.stopPropagation();
  };
  const handleSignout = (event) => {
    signout(() => handleClose(event));
  };

  const handleNavigate = (event, linkUrl) => {
    handleClose(event);
    navigate(linkUrl);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'logout-popover' : undefined;

  return (
    <div className={classes.avatar} onClick={handleClick}>
      <div className={classes.letter}>{firstLetter.toUpperCase()}</div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <List>
          <ListItem>
            <ListItemIcon sx={{
              '&.MuiListItemIcon-root': {
                width: 30,
                height: 30,
                marginRight: 0,
                minWidth: 0,
              },
            }}
            >
              <div className={classes.letter}>{firstLetter.toUpperCase()}</div>
            </ListItemIcon>
            <ListItemText
              sx={{
                '& .MuiTypography-root': {
                  fontSize: '14px',
                  fontWeight: 400,
                  marginLeft: '10px',
                },
              }}
            >
              <div>{email}</div>
              <div className={classes.name}>{merchantName || email.split('@')[0]}</div>
            </ListItemText>
          </ListItem>
          <Divider />
          <ListItem
            disablePadding
          >
            <ListItemButton
              sx={{
                paddingBottom: 0,
              }}
              onClick={(e) => handleNavigate(e, '/account-settings')}
            >
              <ListItemText
                sx={{
                  '& .MuiTypography-root': {
                    fontSize: '14px',
                    fontWeight: 400,
                  },
                }}
                primary="Account settings"
              />
            </ListItemButton>
          </ListItem>
          <ListItem
            disablePadding
          >
            <ListItemButton
              sx={{
                paddingTop: 0,
              }}
              onClick={(e) => handleNavigate(e, '/organization-settings')}
            >
              <ListItemText
                sx={{
                  '& .MuiTypography-root': {
                    fontSize: '14px',
                    fontWeight: 400,
                    // marginLeft: '10px',
                  },
                }}
                primary="Organization settings"
              />
            </ListItemButton>
          </ListItem>
          <Divider />
          <ListItem
            disablePadding
          >
            <ListItemButton
              onClick={handleSignout}
            >
              <ListItemIcon sx={{
                '&.MuiListItemIcon-root': {
                  width: 16,
                  height: 16,
                  marginRight: 0,
                  minWidth: 0,
                },
              }}
              >
                <FontAwesomeIcon icon={faCircleArrowRight} style={{ color: '#5C5F62', fontSize: 16 }} />
              </ListItemIcon>
              <ListItemText
                sx={{
                  '& .MuiTypography-root': {
                    fontSize: '14px',
                    fontWeight: 400,
                    marginLeft: '10px',
                  },
                }}
                primary="Sign out"
              />
            </ListItemButton>
          </ListItem>
        </List>
      </Popover>
    </div>
  );
}

function Navigation({ showNavItems }) {
  const authInfo = useAuthContext();
  const { store: { info } = {} } = useConnectionContext();
  const navs = [{
    icon: faHouse,
    text: 'Dashboard',
    link: '/',
  }, {
    icon: faFileLines,
    text: 'Covers',
    link: '/policies',
  }, {
    icon: faFileInvoiceDollar,
    text: 'Billing',
    link: '/billing',
  }, {
    icon: faGrip,
    text: 'Products',
    link: '/products',
  }];
  const { pathname } = useLocation();
  const checkIsCurrent = (link) => {
    const paths = pathname.split('/');
    const mainPath = paths[1];
    return mainPath === link.split('/')[1];
  };
  const navHeight = showNavItems ? '106px' : '60px';
  return (
    <>
      <div className={classes.wrap} style={{ height: navHeight }}>
        <div className={classes.navbar_title}>
          <div className={classes.navbar}>
            <Logo />
          </div>
          <div className={classes.menu}>
            <Help />
            <Avatar authInfo={authInfo} />
          </div>
        </div>
        {(showNavItems)
          ? (
            <div className={classes.sub_navbar}>
              <div className="navs">
                {navs.map((item, index) => {
                  const isCurrent = checkIsCurrent(item.link);
                  return (
                    <Link
                      key={item.text}
                      className={`nav_item ${`item_${index}`} ${isCurrent ? 'active' : ''}`}
                      to={item.link}
                    >
                      <FontAwesomeIcon
                        className={`nav_icon ${isCurrent ? 'active' : ''}`}
                        icon={item.icon}
                      />
                      <div className="nav_text">
                        {item.text}
                      </div>
                    </Link>
                  );
                })}
                <div className="nav_highlighter" />
              </div>
              <div className={classes.navbar_email}>
                <img src={PrimaryFill} alt="" />
                <span>{info}</span>
              </div>
            </div>

          ) : null}

      </div>
      <div className={classes.nav_placeholder} style={{ height: navHeight }} />
    </>
  );
}
Navigation.propTypes = {
  showNavItems: PropTypes.bool,
};

Navigation.defaultProps = {
  showNavItems: true,
};

export default Navigation;
